<template>
  <div :class="[b(), b('pane', { select: index === parent.curActive })]">
    <slot />
  </div>
</template>

<script>
import create from '../utils/create';
import findParent from '../mixins/find-parent';

export default create({
  name: 'tab-item',

  mixins: [findParent],

  props: {
    title: String,
    disabled: Boolean,
    info: Number
  },

  computed: {
    index() {
      return this.parent.tabs.indexOf(this);
    }
  },

  created() {
    this.findParent('om-tab-group');
    this.parent.tabs.push(this);
  },

  destroyed() {
    this.parent.tabs.splice(this.index, 1);
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/tab-item/index.vue